import { createAsyncThunk } from '@reduxjs/toolkit';
import CustomerAPI from 'config/api/CustomerAPI';
import { getFFLObj } from 'helpers/DataHelper';
import { notify } from 'helpers/NotifyHelper';
import { getDeviceId } from 'helpers/StorageHelper';
import { manageAPICall } from 'store/auth/actions/CommonCrudAction';

// Get Wish List
export const getWishListAPI = createAsyncThunk(
  'wishlist/fetch',
  async (params: any, { rejectWithValue }) => {
    const payload = { session_id: getDeviceId(), ...(params || {}) };
    try {
      const res: any = await manageAPICall(
        CustomerAPI.getWishList.url,
        CustomerAPI.getWishList.method,
        payload
      );
      if (res?.status === false) {
        notify.error(res.message);
        return rejectWithValue(res);
      }
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

// Remove from WishList
export const removeFromWishListAPI = createAsyncThunk(
  'wishlist/remove',
  async (compareProductId: string, { rejectWithValue }) => {
    const payload = {
      product_id: compareProductId,
      session_id: getDeviceId(),
    };
    try {
      const res: any = await manageAPICall(
        CustomerAPI.removeFromWishList.url,
        CustomerAPI.removeFromWishList.method,
        payload
      );
      if (res?.status === false) {
        notify.error(res.message);
        return rejectWithValue(res);
      }
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

// Add to WishList
export const addToWishListAPI = createAsyncThunk(
  'wishlist/add',
  async (productId: string, { rejectWithValue }) => {
    const payload = {
      product_id: productId,
      session_id: getDeviceId(),
    };
    try {
      const res: any = await manageAPICall(
        CustomerAPI.addToWishList.url,
        CustomerAPI.addToWishList.method,
        payload
      );
      if (res?.status === false) {
        notify.error(res.message);
        return rejectWithValue(res);
      }
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const approvedFFLList = async (params: any, callback: any) => {
  const payload = params;
  const response: any = await manageAPICall(
    CustomerAPI.approvedFFLList.url,
    CustomerAPI.approvedFFLList.method,
    payload
  );
  if (response && response.status) {
    callback(response.data);
  }
};
export const apporvedfflOptions = (
  inputValue: string,
  setDisabled = false,
  additionalParams = {}
) =>
  new Promise((resolve) => {
    const payload = {
      filters: {
        search: inputValue,
        ...(additionalParams ? additionalParams : {}),
      },
      limit: 10,
      sort: { created_at: -1 },
    };
    approvedFFLList(payload, (responseData: any) => {
      const listData: any = [];
      responseData.data.forEach(function (element: any) {
        listData.push(getFFLObj(element, setDisabled));
      });
      resolve(listData);
    });
  });
